import { useState } from 'react';

import dayjs from 'dayjs';

type UseCalendarProps = {
  initialDate?: Date;
};

const useCalendar = ({ initialDate = new Date() }: UseCalendarProps = {}) => {
  const [currentDate, setCurrentDate] = useState<Date>(initialDate);

  const getDaysInMonth = (): (Date | null)[] => {
    const startOfMonth = dayjs(currentDate).startOf('month');
    const endOfMonth = dayjs(currentDate).endOf('month');
    const days: (Date | null)[] = [];

    // 이전 달
    const startDay = (startOfMonth.day() + 6) % 7;
    for (let i = 0; i < startDay; i++) {
      days.push(null);
    }

    // 현재 달
    for (let day = 1; day <= endOfMonth.date(); day++) {
      days.push(startOfMonth.date(day).toDate());
    }

    // 다음 달
    const endDay = (endOfMonth.day() + 6) % 7;
    const remainingDays = 6 - endDay;
    for (let i = 0; i < remainingDays; i++) {
      days.push(null);
    }

    return days;
  };

  const goToPrevMonth = () => setCurrentDate((prev) => dayjs(prev).subtract(1, 'month').toDate());
  const goToNextMonth = () => setCurrentDate((prev) => dayjs(prev).add(1, 'month').toDate());

  return {
    currentDate,
    days: getDaysInMonth(),
    goToPrevMonth,
    goToNextMonth,
  };
};

export default useCalendar;
